<template>
  <div :class="['pb-100 mb-pt-60 mb-pb-60', customClass]">
    <div class="container flex mb-flex-wrap">
      <div class="wp-100 maxw-400 mr-100 mb-mr-0 mb-mb-30">
        <h2 class="section-question-title fs-32 fw-700 lh-36 mb-30 mb-fs-28 mb-lh-32">
          Still Have Questions?
        </h2>
        <div class="fs-16 lh-24">
          <slot name="sub-title"></slot>
        </div>
      </div>
      <Collapse :faqs = faqs :expandAll="expandAll"></Collapse>
    </div>
  </div>
</template>

<script>
import Collapse from '~/components/sections/SectionQuestion/Collapse.vue'

export default {
  name: 'SectionQuestion',
  components:{
    Collapse
  },
  props: {
    faqs: {
      type: Array,
      default: null
    },
    customClass: {
      type: String,
      default: ''
    },
    expandAll: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.section-question-title {
  letter-spacing: -0.04em; // v2 display tracking (§Typography Scale L94–96)
}
</style>
